import { useComponentSearchBar } from 'components/component-overview/hooks/use-component-search-bar';
import { useComponentSearchFilters } from 'components/component-overview/hooks/use-component-search-filters';
import { SearchService } from 'components/component-overview/services/SearchService';

export const useComponentSearchQuery = () => {
    const { query, setQuery } = useComponentSearchBar();

    const productFilters = useComponentSearchFilters();

    const showReset = !!query || !SearchService.isInitialSearch(productFilters);

    const resetAll = showReset
        ? () => {
              setQuery('');
              SearchService.resetFilters();
          }
        : undefined;

    return { resetAll, query, setQuery };
};
